import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SummaryApi from '../common';
import displayINRCurrency from '../helpers/displayCurrency';
import addToCart from '../helpers/addToCart';
import Context from '../context';
import { toast } from 'react-toastify';
import AlterCardProduct from '../components/AlterCardProduct';
import BrandCardProduct from '../components/BrandCardProduct';
import { FaTag } from 'react-icons/fa6';
import { useLocation } from 'react-router-dom';
import defaultImage from '../assest/DAWACO_Icon.png'; 
import { useSelector } from 'react-redux';
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';


const ProductDetails = () => {
  const [loadingPage, setLoadingPage] = useState(false);
  const [data, setData] = useState({
    productName: "",
    brandName: "",
    category: "",
    productImage: [],
    description: "",
    price: "",
    sellingPrice: "",
    quantity: 0
  });
  const [currentQuantity, setCurrentQuantity] = useState(1);
  const params = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const productImageListLoading = new Array(4).fill(null);
  const [activeImage, setActiveImage] = useState("");
  const [zoomImageCoordinate, setZoomImageCoordinate] = useState({ x: 0, y: 0 });
  const [zoomImage, setZoomImage] = useState(false);
  const { fetchUserAddToCart } = useContext(Context);
  const navigate = useNavigate();
  const [productData, setProductData] = useState([]);
  const [quantities, setQuantities] = useState({});
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  const user = useSelector(state => state?.user?.user);


  const fetchProductDetails = async () => {
    setLoading(true);
    await fetchData();
    const response = await fetch(SummaryApi.productDetails.url, {
      method: SummaryApi.productDetails.method,
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({ productId: params?.id,type:type })
    });
    setLoading(false);
    const dataResponse = await response.json();
    setData(dataResponse?.data);
    if (dataResponse?.data === null || dataResponse?.data === undefined) {
      navigate('/');
  }
    setActiveImage(dataResponse?.data?.productImage[0]);
    setCurrentQuantity(1); 
    setLoading(false)
  };

  const fetchData = async () => {
    const response = await fetch(SummaryApi.addToCartProductView.url, {
        method: SummaryApi.addToCartProductView.method,
        credentials: 'include',
        headers: {
            "content-type": 'application/json'
        },
        
    });

    const responseData = await response.json();

    if (responseData.success) {
        setProductData(responseData.data);
    }
    
};

  useEffect(() => {
    fetchProductDetails();
  }, [params]);

  const handleMouseEnterProduct = (imageURL) => {
    setActiveImage(imageURL);
  };

  const handleZoomImage = useCallback((e) => {
    setZoomImage(true);
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = (e.clientX - left) / width;
    const y = (e.clientY - top) / height;
    setZoomImageCoordinate({ x, y });
  }, [zoomImageCoordinate]);

  const handleLeaveImageZoom = () => {
    setZoomImage(false);
  };

  const handleAddToCart = async (e, id,productType) => {

    var cartQuantity=0
    const targetProduct = productData.find(product => product.productDetails._id === id);

    var Qty=1

    if(quantities[id]) Qty=quantities[id]

    if(targetProduct)
      cartQuantity=targetProduct.quantity

  
    if ((Qty+cartQuantity) <= data.quantity) {
      await addToCart(e, id,Qty,productType);
      fetchUserAddToCart();

    } else {
      toast.error(` المتاح حاليا بالمخزن"${data.productName}" لقد وصلت للحد الاقصي من `);
    }
    await fetchProductDetails();
  };

  const handleBuyProduct = async (e, id,productType) => {
    await fetchProductDetails();

    var cartQuantity=0
    const targetProduct = productData.find(product => product.productDetails._id === id);

    var Qty=1

    if(quantities[id]) Qty=quantities[id]

    if(targetProduct)
      cartQuantity=targetProduct.quantity

  
    if ((Qty+cartQuantity) <= data.quantity) {
      await addToCart(e, id,Qty,productType);
      fetchUserAddToCart();
    } 
    
    if(user?.role === ROLE.GENERAL || user?.role === ROLE.SALESMAN){
      navigate("/cart");
    }
  };


   // Helper function to continuously adjust quantity
   const startAdjustingQty = (id, direction) => {
    let interval;
    const adjustQty = () => {
        setQuantities(prevQuantities => {
            const cartQuantity = productData.find(product => product.productDetails._id === id)?.quantity || 0;
            

            if (!data) return prevQuantities;

            const currentQty = prevQuantities[id] || 1;
                if ((direction === 'increase' && (currentQty + cartQuantity + 1) <= data.quantity) || 
                    (direction === 'decrease' && currentQty > 1)) {
                    return { ...prevQuantities, [id]: direction === 'increase' ? currentQty + 1 : currentQty - 1 };
                }
                return prevQuantities;
        });
    };

    interval = setInterval(adjustQty, 100); // Adjust every 100ms

    return () => clearInterval(interval);
};


const handleMouseDown = (id, direction) => {
  const stopAdjusting = startAdjustingQty(id, direction);
  const handleMouseUp = () => {
      stopAdjusting();
      window.removeEventListener('mouseup', handleMouseUp);
  };
  window.addEventListener('mouseup', handleMouseUp);
};

const handleQuantityChange = (e, id) => {
  let newQuantity = parseInt(e.target.value, 10);

  if (newQuantity < 1) {
      newQuantity = 1;
  }

  const targetProduct = productData.find(product => product.productDetails._id === id);
  const targetData = data
  let cartQuantity = targetProduct ? targetProduct.quantity : 0;
  if (newQuantity > targetData.quantity-cartQuantity) {
      newQuantity = targetData.quantity-cartQuantity;
  }

  setQuantities(prev => ({ ...prev, [id]: newQuantity}));
 

};

const increaseQty = (id) => {
  const targetProduct = productData.find(product => product.productDetails._id === id);
  const targetData = data
  let cartQuantity = targetProduct ? targetProduct.quantity : 0;
  const currentQty = quantities[id] || 1;

  if ((currentQty + cartQuantity) < targetData.quantity) {
      setQuantities(prev => ({ ...prev, [id]: (prev[id] || 1) + 1 }));
  } else {
      toast.error(` المتاح حاليا بالمخزن"${targetData.productName}" لقد وصلت للحد الاقصي من `);
  }
};

const decreaseQty = (id) => {
  if ((quantities[id] || 1) > 1) {
      setQuantities(prev => ({ ...prev, [id]: (prev[id] || 1) - 1 }));
  }
};










  const isOutOfStock = data?.quantity <= 0;
  const quantity = quantities[data?._id] || 1;

 // Determine if the "+" button should be disabled
  const cartQuantity = productData.find(product => product?.productDetails?._id === data?._id)?.quantity || 0;
  const isIncreaseDisabled = (quantities[data?._id] + cartQuantity) >= data?.quantity;


  useEffect(() => {
    setLoadingPage(true);
    if (user) {
        if (user?.role === ROLE.ADMIN) {
            if (user?.type === "Medicine") {
                navigate("/admin-home");
                setLoadingPage(false);
            } 
            else if(user?.type === "Cosmetic") {
                navigate("/admin-cosmetic-home");
                setLoadingPage(false);
            }
            else if (user?.type ==="Admin"){
                navigate("/admin-panel/all-users");
                setLoadingPage(false);
            }
            
        } 
        else {
          setLoadingPage(false);
        }
    } else {
      setLoadingPage(false);
    }
}, [user, navigate]);

if (loadingPage) {
    return (
        <div className="flex justify-center items-center h-screen">
            <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
        </div>
    );
}



  return (
    <div className='container mx-auto p-4'>
      <div className='min-h-[200px] flex flex-col lg:flex-row gap-4'>
        {/* Product Image */}
        <div className='h-96 flex flex-col lg:flex-row-reverse gap-4'>
          <div className='h-[300px] w-[300px] lg:h-96 lg:w-96 bg-slate-200 relative p-2'>
            <img
              src={activeImage || defaultImage}
              className='h-full w-full object-scale-down mix-blend-multiply'
              onMouseMove={handleZoomImage}
              onMouseLeave={handleLeaveImageZoom}
            />
            {/* Product Zoom */}
            {zoomImage && (
              <div className='hidden lg:block absolute min-w-[500px] overflow-hidden min-h-[400px] bg-slate-200 p-1 -right-[510px] top-0'>
                <div
                  className='w-full h-full min-h-[400px] min-w-[500px] mix-blend-multiply scale-150'
                  style={{
                    background: `url(${activeImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: `${zoomImageCoordinate.x * 100}% ${zoomImageCoordinate.y * 100}%`
                  }}
                />
              </div>
            )}
          </div>

          <div className='h-full'>
            {loading ? (
              <div className='flex gap-2 lg:flex-col overflow-scroll scrollbar-none h-full'>
                {productImageListLoading.map((el, index) => (
                  <div className='h-20 w-20 bg-slate-200 rounded animate-pulse' key={"loadingImage" + index}></div>
                ))}
              </div>
            ) : (
              <div className='flex gap-2 lg:flex-col overflow-scroll scrollbar-none h-full'>
                {data?.productImage?.map((imgURL, index) => (
                  <div className='h-20 w-20 bg-slate-200 rounded p-1' key={imgURL}>
                    <img
                      src={imgURL}
                      className='w-full h-full object-scale-down mix-blend-multiply cursor-pointer'
                      onMouseEnter={() => handleMouseEnterProduct(imgURL)}
                      onClick={() => handleMouseEnterProduct(imgURL)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Product Details */}
        {loading ? (
          <div className='grid gap-1 w-full'>
            <p className='bg-slate-200 animate-pulse h-6 lg:h-8 w-full rounded-full inline-block'></p>
            <h2 className='text-2xl lg:text-4xl font-medium h-6 lg:h-8 bg-slate-200 animate-pulse w-full'></h2>
            <p className='capitalize text-slate-400 bg-slate-200 min-w-[100px] animate-pulse h-6 lg:h-8 w-full'></p>
            <div className='text-blue-600 bg-slate-200 h-6 lg:h-8 animate-pulse flex items-center gap-1 w-full'></div>
            <div className='flex items-center gap-2 text-2xl lg:text-3xl font-medium my-1 h-6 lg:h-8 animate-pulse w-full'>
              <p className='text-blue-600 bg-slate-200 w-full'></p>
              <p className='text-slate-400 line-through bg-slate-200 w-full'></p>
            </div>
            <div className='flex items-center gap-3 my-2 w-full'>
              <button className='h-6 lg:h-8 bg-slate-200 rounded animate-pulse w-full'></button>
              <button className='h-6 lg:h-8 bg-slate-200 rounded animate-pulse w-full'></button>
            </div>
            <div className='w-full'>
              <p className='text-slate-600 font-medium my-1 h-6 lg:h-8 bg-slate-200 rounded animate-pulse w-full'></p>
              <p className='bg-slate-200 rounded animate-pulse h-10 lg:h-12 w-full'></p>
            </div>
          </div>
        ) : (
          <div className='flex flex-col gap-1'>
            <p className='bg-blue-200 text-blue-600 px-2 rounded-full inline-block w-fit'>{data?.brandName}</p>
            <h2 className='text-2xl lg:text-4xl font-medium'>{data?.productName}</h2>
            <p className='capitalize text-slate-400'>{data?.activePharmaceuticalIngredient}</p>
            {data?.sellingPrice > 0 && (
                            <div className='absolute top-2 right-2 bg-blue-600 text-white px-3 py-1 rounded-full text-sm flex items-center'>
                                <FaTag className='mr-1' />
                                <span>{`${Math.round(((data?.price - data?.sellingPrice) / data?.price) * 100)}% خصم`}</span>
                            </div>
                        )}
            <div className='flex items-center gap-2 text-2xl lg:text-3xl font-medium my-1'>
            {data?.sellingPrice > 0 ? (
                                                <>
                                                    <p className='text-blue-800 font-medium'>{displayINRCurrency(data?.sellingPrice)}</p>
                                                    <p className='text-slate-500 line-through'>{displayINRCurrency(data?.price)}</p>
                                                    <div className=' bg-blue-600 text-white px-3 py-1 rounded-full text-sm flex items-center'>
                                <FaTag className='mr-1' />
                                <span>{`${Math.round(((data?.price - data?.sellingPrice) / data?.price) * 100)}% خصم`}</span>
                            </div>
                                                </>
                                            ) : (
                                                <p className='text-blue-800 font-medium'>{displayINRCurrency(data?.price)}</p>
                                            )}
            </div>

            {isOutOfStock ? (
              <div className='my-4'>
                <p className='text-red-600 font-medium'>غير متوفر حاليا بالمخزن</p>
              </div>
            ) : (
              <div className='flex flex-col gap-4'>
              <div className='flex items-center gap-3'>
              <button
                                                    className='w-8 h-8 flex items-center justify-center border-2 border-blue-800 rounded-full text-gray-800'
                                                    onMouseDown={() => handleMouseDown(data?._id, 'decrease')}
                                                    onClick={() => decreaseQty(data?._id)}   
                                                >
                                                    -
                                                </button>
                                                <input
                                                    type='number'
                                                    className='text-lg font-medium mx-10 w-16 text-center border border-gray-300 rounded'
                                                    value={quantity}
                                                    onChange={(e) => handleQuantityChange(e, data?._id)}
                                                    min={1}
                                                />
                                                <button
                                                    className={`w-8 h-8 flex items-center justify-center border-2 border-blue-800 rounded-full text-gray-800 ${isIncreaseDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                                    onMouseDown={() => handleMouseDown(data?._id, 'increase')}
                                                    onClick={() => !isIncreaseDisabled && increaseQty(data?._id)}   
                                                    disabled={isIncreaseDisabled} // Disable button when max quantity is reached
                                                >
                                                    +
                                                </button>
              </div>
              <div className='flex items-center gap-3 my-2'>
                <button
                  className='bg-blue-900 hover:bg-blue-800 text-white px-4 py-2 rounded'
                  onClick={(e) => handleAddToCart(e, params?.id,data?.type)}
                  disabled={isOutOfStock}
                >
                أضف إلى العربة
                </button>
                <button
                  className='bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded'
                  onClick={(e) => handleBuyProduct(e, params?.id,data?.type)}
                  disabled={isOutOfStock}
                >
                  اشتر الآن
                </button>
              </div>
            </div>
            
            )}

            <div className='w-full'>
              <p className='text-slate-600 font-medium my-1'>الوصف</p>
              <p>{data?.description}</p>
            </div>
            {data?.toBonus > 0 && data?.bonusQuantity > 0 && data?.quantity > 0 &&(
            <div className='w-full'>
              <p className='text-green-600 font-medium my-1'>إذا قمت بشراء  {data?.toBonus} قطع ستحصل علي {data?.bonusQuantity} قطع إضافية كهدية </p>
            </div>
            )}
          </div>
            
          
        )}
      </div>

      <BrandCardProduct type={data?.type} category={data?.brandName} id={data?._id} heading={data?.brandName+ " ايضا من"}/>

      <AlterCardProduct type={data?.type} activePharmaceuticalIngredient={data?.activePharmaceuticalIngredient} id={data?._id} heading={"منتجات بديلة"}/>
    </div>
  );
};

export default ProductDetails;
